import { Settings } from '@streamr/tv-engine/~/settings';
const OFF = new Set(['off', '0', 'false']);
const ON = new Set(['on', '1', 'true']);
export function resolveMediaChannelOptions(input) {
    const params = new URLSearchParams(input.search);
    const lifetimeRaw = params.get('mediaChannelLifetimeMs');
    const lifetime = lifetimeRaw === null ? Number.NaN : Number(lifetimeRaw);
    const maxPacketLifeTimeMs = Number.isFinite(lifetime) && lifetime > 0
        ? Math.round(lifetime)
        : undefined;
    const param = params.get('mediaChannel');
    if (param !== null && OFF.has(param)) {
        return { enabled: false, maxPacketLifeTimeMs };
    }
    if (param !== null && ON.has(param)) {
        return { enabled: true, maxPacketLifeTimeMs };
    }
    const stored = input.localStorageValue;
    if (stored !== null && OFF.has(stored)) {
        return { enabled: false, maxPacketLifeTimeMs };
    }
    if (stored !== null && ON.has(stored)) {
        return { enabled: true, maxPacketLifeTimeMs };
    }
    return { enabled: Settings.mediaChannelEnabled, maxPacketLifeTimeMs };
}
/** Browser entry point: page URL + localStorage. */
export function readMediaChannelOptions() {
    let search = '';
    let localStorageValue = null;
    try {
        search = window.location.search;
        localStorageValue = window.localStorage.getItem('mediaChannel');
    }
    catch {
        // no window / storage access: defaults
    }
    return resolveMediaChannelOptions({ search, localStorageValue });
}
